import { TApiResponse } from '@/common/types/response';

import { TFTSWeeklyState } from './types';

export function setTableData(state: TFTSWeeklyState, data: TFTSWeeklyState['tableData']) {
  state.tableData = data;
}

export function setDeliveryTerms(state: TFTSWeeklyState, response: TApiResponse<TFTSWeeklyState['deliveryTerms']>) {
  state.deliveryTerms = response.data;
}

export function setTransportTypes(state: TFTSWeeklyState, response: TApiResponse<TFTSWeeklyState['transportTypes']>) {
  state.transportTypes = response.data;
}

export function setDeliveryGoodsPoints(
  state: TFTSWeeklyState,
  response: TApiResponse<TFTSWeeklyState['deliveryGoodsPoints']>,
) {
  state.deliveryGoodsPoints = response.data;
}

export function setExporters(state: TFTSWeeklyState, response: TApiResponse<TFTSWeeklyState['exporters']>) {
  state.exporters = response.data;
}
